import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid, SxProps, Typography} from '@mui/material';

import StatisticNumbers from '../culture/surveys/components/survey-details/statistic-details/StatisticNumbers';

import {pdfH1} from './styles';
import {EmpionPaper} from '../../../components/EmpionPaper/EmpionPaper';
import {CultureAnalysisPdfContext} from '../../../contexts/CultureAnalysisPdfContext/CultureAnalysisPdfContext';
import {orangeColors} from '../../../layouts/theme/designSystem';

export const KeyData = () => {
  const {t} = useTranslation('pdfDomain');
  const {data, loading} = useContext(CultureAnalysisPdfContext);

  if (loading || !data) {
    return null;
  }

  const survey = data.companySurvey;

  const paperStyles: SxProps = {
    borderRadius: 2,
    marginTop: 2,
    backgroundColor: '#ffffff',
    border: `1px solid ${orangeColors[3]}`,
    padding: '1rem',
  };

  return (
    <Grid padding={3}>
      <Typography variant='h1' sx={pdfH1}>
        {t('keyData.title')}
      </Typography>
      <EmpionPaper sx={paperStyles}>
        <StatisticNumbers survey={survey} state='previous' showCultureTypeDistribution hideMetadata />
      </EmpionPaper>
    </Grid>
  );
};
